import { QueryScheduleBadge } from "shared/ScheduleBadge/QueryScheduleBadge";
import type { VisualQueryDetails } from "lib/visuals/types";
import { Owner, useHasViewPermission } from "lib/permissions/permissions";

function getOwner(queryDetails: VisualQueryDetails): Owner | undefined {
  if (queryDetails.team) {
    return { type: "team", id: queryDetails.team.id };
  }
  if (queryDetails.user) {
    return { type: "user", id: queryDetails.user.id };
  }
}

export function QueryVizScheduleBadge({
  queryDetails,
}: {
  queryDetails?: VisualQueryDetails;
}) {
  const queryId = queryDetails?.query_id;
  const owner = queryDetails && getOwner(queryDetails);
  const hasViewPermission = useHasViewPermission(owner);

  if (queryId === undefined || !hasViewPermission) {
    return null;
  }

  return <QueryScheduleBadge size="M" queryId={queryId} />;
}
